<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'Customers'
    }
</script>

<style lang="scss" scoped>

</style>